import React, { memo } from "react";
import { Button, Modal } from "react-bootstrap";

const InvalidPermissionsDialog = ({ open = false, setOpen = () => {} }) => {
  const onClose = () => {
    setOpen(false);
  };

  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title
          style={{ fontSize: "16px", lineHeight: "22px", fontWeight: 500 }}
        >
          Invalid Access
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-0">
        <div style={{ textAlignLast: "center" }}>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "22px",
              textAlign: "left",
              color: "#1D2026",
              marginBottom: "20px",
            }}
          >
            You do not have permission to perform this task.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-right">
        <Button
          variant="light"
          onClick={onClose}
          className="start-classroom-styles px-3"
        >
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(InvalidPermissionsDialog);
